/**
 * Narrow an unknown value to a plain record, excluding arrays. Deliberately named apart from
 * `@aline/common`'s `getIsRecord`, which returns true for arrays — the two are not
 * interchangeable, and shadowing that name locally proved to be a trap.
 */
export function getIsPlainRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
